const API = require('../../../global/js/modules/api');
const Toaster = require('../modules/toaster');
const INTERVAL = Toaster.delays.slow + 5000;

let polling = false;
let locationGroupSlug = null;
let locationSlug = null;

function noop() {
}

function poll() {
    if (polling) {
        return;
    }

    polling = true;

    let data = {};

    if (locationSlug) {
        data.l = locationSlug;
    }

    if (locationGroupSlug) {
        data.g = locationGroupSlug;
    }

    API.local.fetchRecentBooking(data)
        .then(result => {
            if (!result || result.error) {
                return;
            }

            const message = `${result.name} just booked a ${result.vehicle} at ${result.pickup_location}`;

            Toaster.toast(message, Toaster.delays.slow);
        }, noop)
        .finally(() => {
            polling = false;

            //run again in twice the timeout
            window.setTimeout(poll, INTERVAL * 2);
        });

}

document.addEventListener('DOMContentLoaded', () => {
    const $html = document.querySelector('html');
    let pass = false, locationGroup = false, location = false;

    pass = pass || $html.matches('.home');
    pass = pass || (locationGroup = $html.matches('.locations.location-group:not(.location)'));
    pass = pass || (location = $html.matches('.locations.location'));

    if (!pass) {
        return;
    }

    if (locationGroup) {
        locationGroupSlug = document.location.href.replace(/.*\//, '');
    }
    else if (location) {
        locationSlug = document.location.href.replace(/.*\//, '');
    }

    poll();
});
